(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
  class HomeAbout extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const counter = this.querySelector('[data-count]');
      if (!counter) return;

      const target = Number(counter.dataset.count);
      const from = Number(counter.dataset.from);
      const suffix = counter.dataset.suffix || '';
      counter.textContent = String(from) + suffix;

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        const duration = 1600;
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = String(Math.round(from + (target - from) * eased)) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        setTimeout(() => { counter.textContent = String(target) + suffix; }, duration + 300);
      }, { threshold: 0.6 });
      observer.observe(counter);
    }
  }

  if (!customElements.get('home-about')) {
    customElements.define('home-about', HomeAbout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-overview"] && !Shopify.designMode) return;
  try {
    
  class HomeOverview extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-pane]'));
      this.panes = Array.from(this.querySelectorAll('.home-overview__pane'));

      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.select(item));
        item.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.items.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.items.length) % this.items.length;
          if (next === null) return;
          event.preventDefault();
          this.items[next].focus();
          this.select(this.items[next]);
        });
      });
    }

    select(selectedItem) {
      this.items.forEach((item) => {
        item.setAttribute('aria-pressed', item === selectedItem ? 'true' : 'false');
      });
      this.panes.forEach((pane) => {
        pane.hidden = pane.id !== selectedItem.dataset.pane;
      });
    }
  }

  if (!customElements.get('home-overview')) {
    customElements.define('home-overview', HomeOverview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-timeline"] && !Shopify.designMode) return;
  try {
    
  class JourneyTimeline extends HTMLElement {
    connectedCallback() {
      this.nodes = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.wrap = this.querySelector('[data-scrollwrap]');
      this.sticky = this.querySelector('[data-sticky]');
      this.scroller = this.querySelector('.journey__scroller');
      this.hint = this.querySelector('[data-hint]');
      this.current = -1;
      this.ticking = false;

      this.setStickyOffset();

      this.nodes.forEach((node, index) => {
        node.addEventListener('click', () => this.jumpTo(index));
        node.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.jumpTo(index + 1, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.jumpTo(index - 1, true); }
        });
      });

      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', () => { this.setStickyOffset(); this.onScroll(); });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    setStickyOffset() {
      const header = document.querySelector('.section-header, header.header, .header-wrapper');
      let offset = 16;
      if (header) {
        const position = getComputedStyle(header.closest('.shopify-section-group-header-group, .shopify-section') || header).position;
        if (position === 'sticky' || position === 'fixed') offset += header.getBoundingClientRect().height;
      }
      this.style.setProperty('--journey-top', offset + 'px');
    }

    range() {
      const top = this.wrap.getBoundingClientRect().top + window.scrollY;
      const travel = Math.max(this.wrap.offsetHeight - this.sticky.offsetHeight, 1);
      return { top, travel };
    }

    preload() {
      if (this.preloaded) return;
      this.preloaded = true;
      this.querySelectorAll('.journey__media img').forEach((img) => { img.loading = 'eager'; });
    }

    update() {
      if (!this.preloaded && this.wrap.getBoundingClientRect().top < window.innerHeight * 2.5) this.preload();
      const { top, travel } = this.range();
      const stickyTop = parseFloat(getComputedStyle(this.sticky).top) || 0;
      const progress = Math.min(Math.max((window.scrollY + stickyTop - top) / travel, 0), 1);
      const last = Math.max(this.nodes.length - 1, 1);
      this.style.setProperty('--progress', String(progress));
      const index = Math.round(progress * (this.nodes.length - 1));
      if (index !== this.current) this.show(index);
      if (this.hint) this.hint.style.opacity = progress > 0.04 ? '0' : '';
    }

    show(index) {
      this.current = index;
      this.nodes.forEach((node, i) => {
        const selected = i === index;
        node.setAttribute('aria-selected', selected ? 'true' : 'false');
        node.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      const node = this.nodes[index];
      if (this.scroller && node) {
        const target = node.offsetLeft - (this.scroller.clientWidth - node.offsetWidth) / 2;
        this.scroller.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    jumpTo(index, focus) {
      const clamped = Math.max(0, Math.min(index, this.nodes.length - 1));
      const { top, travel } = this.range();
      const stickyTop = parseFloat(getComputedStyle(this.sticky).top) || 0;
      const fraction = this.nodes.length > 1 ? clamped / (this.nodes.length - 1) : 0;
      window.scrollTo({ top: top - stickyTop + travel * fraction + 1, behavior: 'smooth' });
      if (focus) this.nodes[clamped].focus();
    }
  }

  if (!customElements.get('journey-timeline')) {
    customElements.define('journey-timeline', JourneyTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  class VideoHero extends HTMLElement {
    connectedCallback() {
      this.setupCounters();
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-toggle]');
      if (!this.video || !this.toggle) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) this.setPaused(true);

      this.toggle.addEventListener('click', () => {
        this.setPaused(!this.video.paused);
      });
    }

    setupCounters() {
      const root = this.closest('.video-hero');
      if (!root || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const counters = Array.from(root.querySelectorAll('[data-count]'));
      const strip = root.querySelector('.video-hero__facts');
      if (!counters.length || !strip) return;

      counters.forEach((counter) => { counter.textContent = '0'; });

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        const duration = 1400;
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          counters.forEach((counter) => {
            counter.textContent = String(Math.round(Number(counter.dataset.count) * eased));
          });
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        setTimeout(() => {
          counters.forEach((counter) => { counter.textContent = counter.dataset.count; });
        }, duration + 300);
      }, { threshold: 0.6 });
      observer.observe(strip);
    }

    setPaused(shouldPause) {
      if (shouldPause) {
        this.video.pause();
      } else {
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      }
      this.toggle.setAttribute('aria-pressed', shouldPause ? 'true' : 'false');
      this.toggle.setAttribute('aria-label', shouldPause ? 'Play video' : 'Pause video');
    }
  }

  if (!customElements.get('video-hero')) {
    customElements.define('video-hero', VideoHero);
  }

  } catch(e) { console.error(e); }
})();
})();
